import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query'
import { activityApi } from './activity'
import { queryKeys } from './query-keys'

/**
 * The caller's activity feed for a team (mock-only endpoint). Polls every
 * 20s so status changes made by the body shop surface without a reload.
 */
export function useActivity(teamId: number | null | undefined) {
  return useQuery({
    queryKey: queryKeys.activity.list(teamId ?? 'none'),
    queryFn: () => activityApi.list(Number(teamId)),
    enabled: !!teamId,
    refetchInterval: 20 * 1000,
  })
}

/** Advance the caller's per-team read marker to now. */
export function useMarkActivityRead(teamId: number | null | undefined) {
  const qc = useQueryClient()
  return useMutation({
    mutationFn: () => activityApi.markRead(Number(teamId)),
    onSuccess: () => {
      if (teamId != null) {
        qc.invalidateQueries({ queryKey: queryKeys.activity.list(teamId) })
      }
    },
  })
}
